import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import router from './router' // 引入配置好的路由
import 'bootstrap/dist/css/bootstrap.min.css';  // 引入 Bootstrap CSS
import 'bootstrap';  // 引入 Bootstrap JS（如果需要）
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { i18n } from "./i18n";


const app = createApp(App)
app.use(ElementPlus) 
app.use(createPinia());
app.use(router)  // 使用 Vue Router
app.use(i18n)
app.mount('#app')  // 挂载 Vue 应用

